export default __webpack_public_path__ + "static/media/profilePic.e3c1c9f0.jpg";